import { ergoTreeFromAddress } from "../../entities/ergoTree";
export class DefaultTransactions {
    constructor(prover, txAsm) {
        this.prover = prover;
        this.txAsm = txAsm;
    }
    async simple(recipient, ctx) {
        const outputGranted = ctx.inputs.totalOutputWithoutChange;
        const out = {
            value: outputGranted.nErgs - ctx.feeNErgs,
            ergoTree: ergoTreeFromAddress(recipient),
            creationHeight: ctx.network.height,
            assets: outputGranted.assets,
            additionalRegisters: {}
        };
        const req = {
            inputs: ctx.inputs,
            dataInputs: [],
            outputs: [out],
            changeAddress: ctx.changeAddress,
            feeNErgs: ctx.feeNErgs
        };
        return this.prover.sign(this.txAsm.assemble(req, ctx.network));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNhY3Rpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3dhbGxldC9zZXJ2aWNlcy90cmFuc2FjdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS0EsT0FBTyxFQUFDLG1CQUFtQixFQUFDLE1BQU0seUJBQXlCLENBQUE7QUFNM0QsTUFBTSxPQUFPLG1CQUFtQjtJQUM5QixZQUE0QixNQUFjLEVBQWtCLEtBQWtCO1FBQWxELFdBQU0sR0FBTixNQUFNLENBQVE7UUFBa0IsVUFBSyxHQUFMLEtBQUssQ0FBYTtJQUFHLENBQUM7SUFFbEYsS0FBSyxDQUFDLE1BQU0sQ0FBQyxTQUFrQixFQUFFLEdBQXVCO1FBQ3RELE1BQU0sYUFBYSxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsd0JBQXdCLENBQUE7UUFDekQsTUFBTSxHQUFHLEdBQUc7WUFDVixLQUFLLEVBQUUsYUFBYSxDQUFDLEtBQUssR0FBRyxHQUFHLENBQUMsUUFBUTtZQUN6QyxRQUFRLEVBQUUsbUJBQW1CLENBQUMsU0FBUyxDQUFDO1lBQ3hDLGNBQWMsRUFBRSxHQUFHLENBQUMsT0FBTyxDQUFDLE1BQU07WUFDbEMsTUFBTSxFQUFFLGFBQWEsQ0FBQyxNQUFNO1lBQzVCLG1CQUFtQixFQUFFLEVBQUU7U0FDeEIsQ0FBQTtRQUNELE1BQU0sR0FBRyxHQUFHO1lBQ1YsTUFBTSxFQUFFLEdBQUcsQ0FBQyxNQUFNO1lBQ2xCLFVBQVUsRUFBRSxFQUFFO1lBQ2QsT0FBTyxFQUFFLENBQUMsR0FBRyxDQUFDO1lBQ2QsYUFBYSxFQUFFLEdBQUcsQ0FBQyxhQUFhO1lBQ2hDLFFBQVEsRUFBRSxHQUFHLENBQUMsUUFBUTtTQUN2QixDQUFBO1FBQ0QsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxHQUFHLEVBQUUsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUE7SUFDaEUsQ0FBQztDQUNGIn0=